import { render, staticRenderFns } from "./SingleStoreResultCompactVariant.vue?vue&type=template&id=72425f00&"
import script from "./SingleStoreResultCompactVariant.vue?vue&type=script&lang=js&"
export * from "./SingleStoreResultCompactVariant.vue?vue&type=script&lang=js&"
import style0 from "./SingleStoreResultCompactVariant.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports